<template>

  <div class="container file-list">

    <div v-if="mode == 'page'" class="">
      <div class="row-wrap border-radius-m py-2_5 px-4">
        <div class="is-fs-l my-1"><div class="is-bold mb-1">{{ title }}</div>
          <div class="has-text-light is-fs-s">文件可公开查看</div>
        </div>
        <div class="grow" />
        <div v-show="$route.params.menu === 'me'">
          <el-button type="primary" plain @click="onUpload">上传文件</el-button>
          <el-button type="default" plain @click="onManageTag">标签管理</el-button>
        </div>
      </div>
    </div>

    <div v-if="mode == 'dialog'" class="px-4 py-2_5 border-b has-bg-white" style="position: sticky; top: 0; left: 0; z-index: 10;">
      <div class="row-wrap">
        <h1 class="is-fs-m my-0">素材</h1>
        <div class="grow" />
        <div>
          <el-button type="default" @click="onUpload">上传文件</el-button>
          <el-button v-show="maxSelect > 0" type="primary" @click="onSelectDone">完成 ({{ selList.length }}/{{ maxSelect }})</el-button>
        </div>
      </div>
    </div>

    <div class="has-bg-white row-wrap border-radius-top-m py-2_5 px-4 border-b">
      <el-input v-model="keywords" class="mr-2 my-1" placeholder="搜索文件名" style="width: 240px" @change="onSearch">
        <template #append>
          <el-button @click="onSearch"><i class="iconfont icon-search " /></el-button>
        </template>
      </el-input>
      <div class="grow" />
      <el-select
        v-show="!(mode === 'page' && $route.params.menu === 'admin')"
        v-model="tagValue"
        v-loading="$store.state.app.loadingList.includes('listTag')"
        class="my-1"
        style="width: 240px"
        placeholder="标签分类"
        @change="onTagChange"
      >
        <el-option v-for="item in tagList" :key="item.id.toString()" :label="item.tag" :value="item.id.toString()" />
      </el-select>
    </div>

    <div class="has-bg-white row-wrap border-radius-top-m py-2_5 px-4 border-b">
      <div>
        <div class="inline-block mr-4 my-1">
          <el-checkbox v-model="allCheckBoxSlected" @change="onAllCheck" />
        </div>
        <div class="mr-4 my-1 inline-block">已选 {{ selList.length }} </div>
        <div class="inline-block" @click.stop>
          <el-dropdown trigger="click" class="mr-4" @command="handleBatchCommand">
            <div class="el-dropdown-link">
              <div class="cursor-hand has-text-primary"><span>操作</span> <span class="iconfont icon-down" /></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleBatchCommand('batchDel')">批量删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

      </div>
    </div>

    <div>
      <div v-if="$store.state.app.loadingList.includes('fetchData')" class="has-bg-white py-2_5 px-4 border-radius-bottom-m">
        <div v-loading="$store.state.app.loadingList.includes('fetchData')" />
      </div>
      <div v-if="list && list.items.length <= 0" class="has-bg-white border-radius-bottom-m has-text-light text-center py-2_5 px-4">
        <el-empty :image-size="100" description="暂无数据" />
      </div>

      <div v-if="list && list.items.length > 0" class="has-bg-white border-radius-bottom-m">
        <div v-for="item in list.items" :key="item.id.toString()" class="py-2_5 px-4 my-list-item">
          <div class="row-start">
            <div class="mr-4">
              <el-checkbox :key="item.id.toString()" v-model="item.selected" label="" class="mb-2_5" @change="onItemCheck(item)" />
            </div>
            <div
              v-if="['image/png', 'image/jpeg', 'image/webp'].includes(item.type)"
              class="mr-4 border-a border-radius-m cursor-hand my-file-icon no-shrink"
              @click="viewFile(item.url)"
            >
              <el-image :src="`${item.url}?suffix=_thumb`" fit="contain" class="my-thumb" />
            </div>
            <div v-else class="mr-4 border-a border-radius-m my-file-icon flex-center cursor-hand no-shrink" @click="viewFile(item.url)">
              <div>
                <i v-if="item.type.startsWith('audio/')" class="iconfont icon-sound has-text-light " />
                <i v-else-if="item.type.startsWith('video/')" class="iconfont icon-video has-text-light " />
                <i v-else-if="item.type.startsWith('image/')" class="iconfont icon-image has-text-light " />
                <i v-else class="iconfont icon-file has-text-light " />
              </div>
            </div>
            <div class="grow">
              <div class="row-between align-start my-2_5">
                <div type="primary" class="is-fs-l mr-2 word-break-all cursor-hand mb-2_5 mr-4" style="flex-basis:85%;" :title="item.name" @click="viewFile(item.url)">
                  {{ item.name }}
                </div>

              </div>
              <div class="row-wrap has-text-light my-2_5">
                <!-- <div class="my-url my-2_5 cursor-hand" title="点击复制网址" @click="copyText(item.url)">{{ item.url }}</div> -->
                <div class="mb-2_5 mr-4"><span><i class="iconfont icon-file" /> 大小 </span><span>{{ item.sizeName }}</span></div>
                <div class="mb-2_5 mr-4" title="上传时间"><i class="iconfont icon-time-circle" /> 上传 {{ formatDate(new Date(item.update_time * 1000), "yyyy-M-d hh:mm") }}</div>
                <div v-if="item.user_id" class="mb-2_5 mr-4" title="上传人"><i class="iconfont icon-user" /> {{ item.user_nickname }}</div>
              </div>
              <div class="row-wrap my-2_5" @click.stop>
                <div class="has-text-primary cursor-hand mr-4" @click="copyText(item.url)">复制网址</div>
                <div class="has-text-primary cursor-hand mr-4" @click="onItemDel(item)">删除</div>
                <el-dropdown trigger="click" class="mr-4" @command="handleCommand">
                  <div class="el-dropdown-link">
                    <div class="has-text-primary cursor-hand">更多</div>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="beforeHandleCommand(item, 'tag')">标签</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="my-2_5 flex-center">
      <el-pagination
        :page-size="perPage"
        layout="prev, pager, next"
        :background="true"
        :total="totalCount"
        :hide-on-single-page="totalCount <= perPage"
        :current-page="pageNo"
        @current-change="onPageChange"
      />
    </div>

    <!-- 对话框 -->
    <DlgTagManagement
      v-model="dlgTagManagement.val"
      :org-id="dlgTagManagement.orgId"
      :tag-type="dlgTagManagement.tagType"
      @closed="onDlgTagManagementClosed"
    />

    <DlgSetTag v-model="dlgSetTag.val" :params="dlgSetTag.params" @manage="onDlgTagManagementClosed" />
    <DlgUpload v-model="dlgUpload.val" :params="dlgUpload.params" @closed="onDlgUploadClosed" />
  </div>

</template>

<script>
// import config from '@/config/index'
import { listOrgMyFile, delOrgMyFile, listOrgFile, delOrgFile, batchDelOrgMyFile, batchDelOrgFile } from '@/api/file'
import { listTag } from '@/api/util'
import config from '@/config/index'
import DlgTagManagement from '@/components/DlgTagManagement.vue'
import DlgSetTag from '@/components/DlgSetTag.vue'
import { formatDate, humanFileSize } from '@/utils/index'
import DlgUpload from '@/components/DlgUpload.vue'
import mixinGlobal from '@/mixinGlobal.js'

export default {
  name: 'FileList',
  components: {
    DlgTagManagement,
    DlgSetTag,
    DlgUpload
  },
  mixins: [mixinGlobal],
  props: {
    fileType: {
      type: String,
      default: ''
    },
    orgId: {
      type: String,
      default: '0'
    },
    mode: {
      type: String,
      default: 'page' // or dialog, page-org-me, page-org-admin
    },
    maxSelect: {
      type: Number,
      default: 1000000
    },
    minSize: {
      type: Number,
      default: 0
    },
    maxSize: {
      type: Number,
      default: 100 * 1000 * 1000 * 1000 // 100G，不限制
    }

  },
  // filters: {
  //   statusFilter(status) {
  //     const statusMap = {
  //       published: 'success',
  //       draft: 'gray',
  //       deleted: 'danger'
  //     }
  //     return statusMap[status]
  //   }
  // },
  data() {
    return {
      title: '素材',
      list: null,
      pageNo: 1,
      keywords: '',
      tagList: [],
      tagValue: '',

      // checbox
      allCheckBoxSlected: false,
      // selList: [],

      dlgSetTag: {
        val: {
          visible: false,
          item: null
        },
        params: {
          orgId: '',
          tagType: 0
        }
      },

      dlgTagManagement: {
        val: {
          visible: false,
          dirty: false
        },
        orgId: this.orgId,
        tagType: config.TAG_TYPE_FILE
      },
      dlgUpload: {
        val: {
          visible: false
        },
        params: {
          actionUrl: process.env.VUE_APP_BASE_API + `/file/upload_org_my_file?org_id=${this.orgId}`,
          limit: 10000,
          type: this.fileType,
          maxSize: this.maxSize
        }
      }
    }
  },
  computed: {
    dataQuery() {
      let q = `?org_id=${this.orgId}&expand=tags&page=${this.pageNo}`
      if (this.fileType) {
        q += `&type=${this.fileType}`
      }
      if (this.search) {
        q += `&search=${this.keywords}`
      }
      if (this.tagValue) {
        q += `&tag=${this.tagValue}`
      }
      q += `&size_range=${this.minSize}-${this.maxSize}`
      return q
    },
    perPage() {
      return this.list?._meta?.perPage || 30
    },
    totalCount() {
      return this.list?._meta?.totalCount || 0
    },
    selList() {
      let list = []
      if (this.list?.items) {
        list = this.list.items.filter(item => item.selected)
      }

      return list
    }
  },
  watch: {
    // list: {
    //   // eslint-disable-next-line no-unused-vars
    //   handler(newValue, oldValue) {
    //     const list = []
    //     if (this.list.items) {
    //       this.list.items.forEach(item => {
    //         if (item.selected) list.push(item)
    //       })
    //     }

    //     this.selList = list
    //   },
    //   deep: true
    // }
  },
  created() {
    console.log('FileList created()')
    this.title = this.$route.params.menu === 'admin' ? '全部素材' : '我的素材'
  },
  mounted() {
    console.log('FileList mounted()')
    this.fetchData(this.dataQuery)
    this.listTag()
  },
  methods: {
    formatDate,
    async fetchData(query) {
      let data

      if (this.$route.params.menu === 'admin') {
        data = await listOrgFile({
          query: query
        }, 'fetchData')
      } else {
        data = await listOrgMyFile({
          query: query
        }, 'fetchData')
      }

      console.log(data)
      data.items.forEach(item => {
        item.url = process.env.VUE_APP_BASE_API + `/file/${item.id}`
        item.sizeName = humanFileSize(item.size)
      })
      this.list = data
    },
    async listTag(query) {
      this.listLoading = true
      this.tagList = await listTag({
        query: `?org_id=${this.orgId}&tag_type=${config.TAG_TYPE_FILE}`
      }, 'listTag')
      this.listLoading = false
      this.tagList.unshift({
        id: '',
        tag: '全部'
      })
    },
    onUpload() {
      const that = this
      that.dlgUpload.val.visible = true
    },
    onDlgUploadClosed(isChanged) {
      if (isChanged) this.fetchData(this.dataQuery)
    },
    onManageTag() {
      this.dlgTagManagement.val.visible = true
    },
    onDlgTagManagementClosed(isChanged) {
      if (isChanged) this.listTag()
    },
    onSearch() {
      this.pageNo = 1
      this.fetchData(this.dataQuery)
    },
    onTagChange() {
      this.pageNo = 1
      this.fetchData(this.dataQuery)
    },
    // 切换页码
    onPageChange(pageNo) {
      this.pageNo = pageNo
      this.fetchData(this.dataQuery)
      if (this.mode === 'dialog') {
        document.querySelector('.file-list').scrollIntoView()
        // window.scrollTo(0, 0) // FIXME
      } else {
        window.scrollTo(0, 0)
      }
    },
    onItemDel(item) {
      const that = this
      that.$confirm('确认要删除？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        let res

        if (this.$route.params.menu === 'admin') {
          res = await delOrgFile({
            query: `?org_id=${this.orgId}&file_id=${item.id}`
          }, 'delFile')
        } else {
          res = await delOrgMyFile({
            query: `?org_id=${this.orgId}&file_id=${item.id}`
          }, 'delFile')
        }
        console.log(res)
        this.fetchData(this.dataQuery)
        // that.list.items.splice(index, 1)
        that.$message({
          message: '操作成功',
          type: 'success',
          center: true
        })
      }).catch(() => {})
    },

    // 查看文件
    viewFile(url) {
      window.open(url, '_blank')
    },

    handleCommand(command) {
      const that = this
      console.log(command)

      if (command.command === 'tag') {
        that.dlgSetTag.val.visible = true
        that.dlgSetTag.val.item = command.item

        that.dlgSetTag.params.orgId = that.orgId
        that.dlgSetTag.params.tagType = config.TAG_TYPE_FILE
        return
      }
    },
    beforeHandleCommand(item, command) {
      return {
        item: item,
        command: command
      }
    },
    handleBatchCommand(command) {
      const that = this
      console.log(command)

      if (command.command === 'batchDel') {
        console.log(that.selList)

        that.$confirm('确认要删除？', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          let res

          if (this.$route.params.menu === 'admin') {
            res = await batchDelOrgFile({
              query: `?org_id=${this.orgId}`,
              data: {
                file_id_list: that.selList.map(item => item.id)
              }
            }, 'batchDelFile')
          } else {
            res = await batchDelOrgMyFile({
              query: `?org_id=${this.orgId}`,
              data: {
                file_id_list: that.selList.map(item => item.id)
              }
            }, 'batchDelFile')
          }
          console.log(res)
          this.fetchData(this.dataQuery)
          // that.list.items.splice(index, 1)
          that.$message({
            message: '操作成功',
            type: 'success',
            center: true
          })
        }).catch(() => {})
        return
      }
    },
    beforeHandleBatchCommand(command) {
      return {
        command: command
      }
    },
    onAllCheck() {
      const that = this
      if (!that.list.items) return
      that.list.items.forEach(item => {
        that.$set(item, 'selected', that.allCheckBoxSlected)
      })
      // this.selList = this.list.items.filter(item => item.selected)
    },
    onItemCheck(item) {
      // console.log(item.selected)
      // if (this.selList.length > this.maxSelect) {
      //   item.selected = false
      //   this.$message.error('最多只能选择' + this.maxSelect + '个')
      //   return
      // }

      // this.selList = this.list.items.filter(item => item.selected)
    },
    onSelectDone() {
      const that = this
      if (that.selList.length > that.maxSelect) {
        that.$message({
          type: 'error',
          message: '所选数量超过限制',
          center: true
        })
        return
      }
      if (that.selList.find(item => item.size > that.maxSize)) {
        that.$message({
          type: 'error',
          message: '单个文件大小不能超过 ' + humanFileSize(that.maxSize),
          center: true
        })
        return
      }
      that.$emit('selected', that.selList)
    }
  }
}
</script>
<style lang="scss" scoped>
.my-file-icon {
  width: 90px;
  height: 90px;

  .iconfont {
    font-size: 30px;
  }
}
.my-thumb {
  display: block;
  width: 100%;
  height: 100%;
}

// ::v-deep {
//   .el-checkbox__inner {
//     border-color: #06f;
//   }
// }
</style>
